var cifDe = ["301 181", "<g fill='none'><path fill='#000' d='M.5.5h300v180H.5z'/><path fill='#D00' d='M.5 60.5h300v120H.5z'/><path fill='#FFCE00' d='M.5 120.5h300v60H.5z'/></g>"];

export { cifDe };
